import styled from 'styled-components';
import { WhiteSection } from 'components/base/layout-components';
import { SIZES } from 'common/constants/sizes';
import { getColor } from 'common/constants/_colors';
import { StyledWidgetHeader } from 'components/base/common-styles';
import { SIDEBAR_WIDE_WIDTH } from 'common/constants/SidebarView';

const FTE_WIDTH = '30vw';

export const StyledGraphViewOptions = styled.div`
  display: flex;
  margin-left: auto;
`;

export const StyledResourceTypeDropDown = styled.div`
  margin-left: 1rem;
  margin-right: 1rem;
  & .MuiSelect-root {
    width: auto;
    min-width: 9rem;
  }
`;

export const StyledLink = styled.a`
  color: ${getColor('dodgerBlue')};
  text-decoration: none;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`;

export const StyledGraphsRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledGraphHeader = styled(StyledWidgetHeader)`
  display: flex;
  align-items: center;
  height: 10%;
`;

export const StyledGraphMain = styled.main`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 90%;
`;

export const StyledResourceAllocationOverview = styled.div`
  font-size: ${SIZES.medium};
  & ${WhiteSection} {
    padding: 2rem;
  }

  & ${StyledGraphsRow} {
    margin-top: 1rem;
    margin-bottom: 1rem;
    display: flex;
    width: 100%;
    height: 40rem;
    overflow: hidden;

    & .fte-allocation {
      width: ${FTE_WIDTH};
    }
    & .allocation-over-time {
      width: calc(100vw - ${FTE_WIDTH} - ${SIDEBAR_WIDE_WIDTH} - 3rem);
      margin-left: 1rem;
    }
  }
`;
